import React, { useContext, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useHistory } from "react-router-dom";
import ActionTable from "../../../components/table/ActionTable";
import { formatDateTime, mergeParams } from "../../../helpers/helpers";
import Form from "../../../components/form";
import comunidade from "../../../services/comunidade";
import AppContext from "../../../container/context";

export default function Lista({ location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        nome: "",
        exibirInativos: false,
      },
      location
    )
  );
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listar();
  }, []);

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    comunidade
      .get("admin/produtos/listar", filtrosEnviar)
      .then((res) => {
        console.log("produtos", res);
        // const registros = res;
        // registros.forEach((r) => {
        //   r.data = formatDateTime(r.registro, "D/M/Y h:m");
        //   r.status =
        //     listaSituacao.find((situacao) => situacao.id === r.situacao)
        //       ?.nome || "Situação não encontrada";

        //   if (r.situacao === 2) {
        //     if (r.modalidadePagamento === 1) {
        //       r.status = "Aguadando pagamento (boleto bancário)";
        //     }
        //     if (r.modalidadePagamento === 2) {
        //       r.status = "Aguadando pagamento (cartão de crédito)";
        //     }
        //     if (r.modalidadePagamento === 3) {
        //       r.status = "Aguadando pagamento (pix)";
        //     }
        //   }
        // });
        setRegistros(res);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os acompanhamentos. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: filtros.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativos",
        space: 4,
        value: filtros.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: listar,
    },

    urlParams: true,
    history,
    location,
  };

  const tPedidos = {
    title: "Produtos",
    onLineClick: (id) => history.push(`/app/comunidade-produtos/${id}`),
    key: "id",
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
    ],
    array: registros,
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? <CircularProgress /> : <ActionTable structure={tPedidos} />}
    </div>
  );
}
